// extracted by mini-css-extract-plugin
export default {"list":"SelectedFiltersList_list__tjHXy","visibleChip":"SelectedFiltersList_visibleChip__5W0ve","inActiveFilterChip":"SelectedFiltersList_inActiveFilterChip__6idXw"};